import { z } from 'zod';
import { UseSchema } from '../../common';
import { annotationBaseDtoSchema } from './annotation-create.input';

export const annotationUpdateDtoSchema = annotationBaseDtoSchema;

@UseSchema(annotationUpdateDtoSchema)
export class AnnotationUpdateDto {}
export interface AnnotationUpdateDto extends z.input<typeof annotationUpdateDtoSchema> {}
